import React from "react";
import { FaUserShield, FaCarAlt, FaTools, FaSmileBeam } from "react-icons/fa";
import "./About.css"; // External CSS file for styling

export default function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1 className="about-title">About Rahul Cabs</h1>
        <p className="about-subtitle">
          We ensure a safe, comfortable, and reliable journey every time.
        </p>

        <ul className="about-points">
          <li>
            <FaUserShield className="icon" /> Trusted & Verified Drivers
          </li>
          <li>
            <FaCarAlt className="icon" /> Well-Maintained & Clean Vehicles
          </li>
          <li>
            <FaTools className="icon" /> Regular Vehicle Service & Safety Checks
          </li>
          <li>
            <FaSmileBeam className="icon" /> Customer-Centric & Friendly Service
          </li>
        </ul>
      </div>
    </div>
  );
}
